import { differenceInCalendarDays } from "date-fns";

const checkTicketsByDay = (tickets, days) => {

    return tickets / days;
}

export default checkTicketsByDay;